import React , { Component } from 'react';
import {Button} from 'reactstrap';

export default class ActionButton extends Component {
    render() {
      return (
        <Button color={this.props.color} disabled={this.props.disabled} id={this.props.id} value={this.props.value} className={this.props.className} size={this.props.size} onClick={this.props.button_click}>{this.props.icon} {this.props.button_name}</Button>
      )
    }
  }
  


// WEBPACK FOOTER //
// ./src/shared/components/ActionButton/index.js